import React, { createContext, useContext } from 'react';

export interface HeadComponentProps {
  children: React.ReactNode;
}

export type HeadComponentType = React.ComponentType<HeadComponentProps>;

interface HeadContextValue {
  HeadComponent: HeadComponentType;
}

const HeadContext = createContext<HeadContextValue | undefined>(undefined);

interface HeadProviderProps {
  HeadComponent: HeadComponentType;
  children: React.ReactNode;
}

export const HeadProvider: React.FC<HeadProviderProps> = ({ HeadComponent, children }) => {
  return <HeadContext.Provider value={{ HeadComponent }}>{children}</HeadContext.Provider>;
};

export const useHead = (): HeadComponentType => {
  const context = useContext(HeadContext);
  if (!context) {
    throw new Error('useHead must be used within a HeadProvider');
  }
  return context.HeadComponent;
};
